<script setup>
import { useStore } from "vuex";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useLocale, useTheme } from "vuetify";

const $theme = useTheme();
const $store = useStore();
const $loading = useLoading();
const { t } = useLocale();

const snackbar = reactive({
  show: false,
  y: "top",
  x: null,
  multiLine: true,
  mode: "",
  timeout: 3000,
  text: "",
  color: "",
});

const darkTheme = ref(false);
const loader = ref(null);
const loading = computed(() => $store.state.loader.loading);
const alertTrigger = computed(() => $store.state.alert.trigger);

watch(loading, (newState) => {
  if (newState) {
    loader.value = $loading.show({
      // Optional parameters
      container: null,
      color: $theme.current.value.colors.primary,
      loader: "spinner",
      height: 50,
      backgroundColor: "#333",
      opacity: 0.8,
      canCancel: false,
    });
  } else {
    if (loader.value !== undefined) loader.value.hide();
  }
});

watch(alertTrigger, (newState) => {
  if (newState > 0) {
    snackbar.text = t($store.state.alert.message);
    snackbar.y = "bottom";
    snackbar.show = true;
  } else {
    snackbar.show = false;
  }
});

onMounted(() => {
  darkTheme.value = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";
  if (darkTheme.value) {
    document.querySelector("html").classList.add("dark");
  }
});
</script>

<template>
  <v-app :theme="darkTheme ? 'myDark' : 'myLight'">
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :bottom="snackbar.y === 'bottom'"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :right="snackbar.x === 'right'"
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :vertical="snackbar.mode === 'vertical'"
    >
      {{ t(snackbar.text) }}
      <v-btn
        icon="fal fa-times"
        color="transparent"
        flat
        @click="snackbar.show = false"
      />
    </v-snackbar>

    <router-view />
  </v-app>
</template>

<style>
/*Hide recaptcha!
 https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge-what-is-allowed
 */
.grecaptcha-badge {
  visibility: hidden;
}

.dark .m-popover-panel{
  color: white !important;
}
</style>
